<template>
    <div class="w-full bg-eblack-100/70 rounded-lg overflow-y-auto ">
        <div class="border-b py-2 max-h-full flex flex-col gap-4 ">
            <div class="bg-slate-200 rounded-md flex p-2">
                <div class="w-full flex flex-col gap-3">
                    <label 
                    for="services"
                    class="text-sm">{{ $t("packages.auto.servicios_actuales_disponibles") }}</label>
                    <div class="w-full flex flex-col py-1 px-4 max-h-60 overflow-y-auto bg-slate-50">
                        <div
                        v-for="service in services" 
                        :key="service.id"
                        class="flex items-center mb-4" >
                            <input 
                            type="checkbox"
                            :value="service.id"
                            v-model="selectedServices"
                            class="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-2 ">
                            <label class="ms-2 text-sm font-medium text-gray-900">{{ service.name }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-slate-200 rounded-md flex p-2 border-t">
                <div class="w-full flex flex-col gap-3">
                    <label 
                    for="services"
                    class="text-sm">{{ $t("packages.auto.servicios_escogidos") }}</label>
                    <div class="w-full flex flex-wrap max-h-24 overflow-y-auto gap-2">
                        <span class="bg-white border text-xs font-medium me-2 px-2.5 py-0.5 rounded" v-for="service in selectedServices" :key="service">
                            {{ getServiceName(service) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['services'],
        name:"ServiceTab",
        data(){
            return {
                selectedServices:[]
            }
        },
        methods:{

            getServiceName(id){
                let service = this.services.filter(service => service.id == id);
                let name = "";

                if(service.length > 0){
                    name = service[0].name
                }

                return name
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>